<div class="section">
  <div class="section__head">
    <span class="section__eyebrow">People<span class="sgl-arrows" aria-hidden="true"></span></span>
    <span class="section__spacer"></span>
    <button
      type="button"
      class="m-btn m-btn-secondary section__add-btn"
      [disabled]="adding"
      (click)="addOpen = !addOpen">
      <mat-icon>add</mat-icon>
      Add person
    </button>
  </div>

  @if (addOpen) {
    <div class="section__add-panel">
      <input
        class="section__add-search"
        type="text"
        [formControl]="searchControl"
        placeholder="Search people not yet assigned…" />

      <div class="section__add-results">
        @for (contact of filteredContacts$ | async; track trackByContactId($index, contact)) {
          <button type="button" class="section__sugg" (click)="selectContact(contact)">
            <app-avatar [displayName]="contact.displayName" [photoUrl]="contact.photoUrl" [size]="28"></app-avatar>
            <span class="section__sugg-text">
              <span class="section__sugg-name">{{ contact.displayName }}</span>
              <span class="section__sugg-sub">{{ contact.jobTitle }}</span>
            </span>
            <mat-icon class="section__sugg-plus">add</mat-icon>
          </button>
        } @empty {
          <div class="section__add-empty">No unassigned people match.</div>
        }
      </div>

      <button type="button" class="section__create-new" (click)="createNewContact()">
        <mat-icon>person_add</mat-icon>
        Create a new person contact…
      </button>
    </div>
  }

  @if (people.length) {
    <div class="section__list" cdkDropList (cdkDropListDropped)="drop($event)">
      @for (person of people; track trackByAssignmentId($index, person); let i = $index) {
        <div class="orow" cdkDrag cdkDragBoundary=".section__list">
          <mat-icon class="orow__handle">drag_indicator</mat-icon>
          <span class="orow__position">{{ i + 1 }}</span>
          <app-avatar [displayName]="person.displayName" [photoUrl]="person.photoUrl" [size]="32"></app-avatar>

          <div class="orow__info">
            <div class="orow__row1">
              <span class="orow__name">{{ person.displayName }}</span>
              <span class="orow__job">{{ person.jobTitle }}</span>
              <span class="orow__tag"><mat-icon>person</mat-icon>Person</span>
              <app-is-active [isActive]="person.isActive"></app-is-active>
            </div>

            <div class="orow__row2">
              <span class="orow__micro-label">Role</span>
              <div class="orow__role-input-wrap">
                <input
                  class="tinp"
                  [value]="person.title ?? ''"
                  placeholder="Role for this customer — e.g. Main sponsor (optional)"
                  (change)="updateTitle(person.contactId, $any($event.target).value)" />
                @if (person.title) {
                  <button
                    type="button"
                    class="orow__clear-role"
                    (click)="updateTitle(person.contactId, '')"
                    aria-label="Clear role">
                    &times;
                  </button>
                }
              </div>
            </div>

            <div class="orow__row3">
              <label class="orow__check">
                <input
                  type="checkbox"
                  [checked]="resolveEffectiveVisibility(person.showMobilePhone, person.defaultShowMobilePhone)"
                  (change)="toggleVisibility(person.contactId, 'showMobilePhone', $any($event.target).checked)" />
                Show mobile
              </label>
              @if (person.showMobilePhone !== null && person.showMobilePhone !== person.defaultShowMobilePhone) {
                <span class="orow__override">
                  Overrides default
                  <button type="button" (click)="resetVisibility(person.contactId, 'showMobilePhone')">reset</button>
                </span>
              }

              <label class="orow__check">
                <input
                  type="checkbox"
                  [checked]="resolveEffectiveVisibility(person.showPhoto, person.defaultShowPhoto)"
                  (change)="toggleVisibility(person.contactId, 'showPhoto', $any($event.target).checked)" />
                Show photo
              </label>
              @if (person.showPhoto !== null && person.showPhoto !== person.defaultShowPhoto) {
                <span class="orow__override">
                  Overrides default
                  <button type="button" (click)="resetVisibility(person.contactId, 'showPhoto')">reset</button>
                </span>
              }
            </div>
          </div>

          <button
            type="button"
            class="orow__remove"
            [attr.aria-label]="'Remove ' + person.displayName"
            title="Remove from this organisation"
            (click)="remove.emit(person.contactId)">
            <mat-icon>close</mat-icon>
          </button>
          <div class="orow__placeholder" *cdkDragPlaceholder></div>
        </div>
      }
    </div>
  } @else {
    <p class="section__empty">No people assigned to this organisation.</p>
  }
</div>
